/**
* @summary - Component that Provides AuthGuard functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import React, { useState, useEffect } from "react";
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getuserId, getUserLoginStatus, removeFCMToken } from "../../utility/tokenUtility";
import {useDispatch } from 'react-redux'; // Importing useSelector from react-redux
import { setHeaderName } from "../../redux/actions/userActions";
import notificationRepository from "../../api/repositories/notificationRepository";
const AuthGuard =  ({ children,value }) => {
  const [isUserStatusLoaded, setIsUserStatusLoaded] = useState(false);
  const [userStatus, setUserStatus] = useState(null);
  let userID = getuserId();  // Fetch roleName once and trim spaces
  let api_value = null;

  const dispatch = useDispatch();
  useEffect(()=>{
      dispatch(setHeaderName('SET_HEADER_NAME',value));
  },[])

  const isAuthenticated = useSelector(state => state.authendicationReducer.isAuthenticated);
  async function getUserLoginStatus(key) {
    // Simulating an asynchronous operation, like fetching from local storage or an API
    return new Promise(async(resolve, reject) => { 
      const status =await localStorage.getItem(key);
              if (status) {
          resolve(status === 'true'); // Resolves to true or false
        } else {
          reject('No status found');
        }
    });
  }
  useEffect(() => {
    const checkUserStatus = async () => {
     const status = await getUserLoginStatus('user_login_status');

      setUserStatus(status);
      setIsUserStatusLoaded(true);
    };

    checkUserStatus();
  }, []);


  if (!isUserStatusLoaded) {
    // You can return a loading spinner or null while the status is being loaded
    return null; 
  }
  
  if (!isAuthenticated && userStatus !==true)  {
    console.log("remove fcm token");
    removeFCMToken('fcmToken');
    notificationRepository?.getFcmToken(userID,api_value);

    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthGuard;
